import React, { useState, useEffect } from "react";
import {
  Button,
  Offcanvas,
  Form,
  Tabs,
  Tab,
  Modal,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import {
  WidgetsOutlined,
  AppsOutlined,
  BookmarkBorderOutlined,
  AddOutlined,
  WallpaperOutlined,
  DeleteForeverOutlined
} from "@mui/icons-material";
import useForm from "../../hooks/useForm";
import useProduct from "../../hooks/useProduct";
import toast from "react-hot-toast";
import GaleriaPgiModal from "../../pages/pgi/GaleriaPgiModal";
import TinyMCE from "./tinyMCE";
import { idGenerator } from "../../helpers/idGenerator";
import useAudit from "../../hooks/useAudit";
import { titleRegex } from "../../helpers/constants";

const SideBarProducts = ({ replicaPgi, isEdit }) => {
  const { products, setProducts, getAllProducts } = useProduct();
  const { createAuditRequest } = useAudit();
  const [showCreateBanner, setShowCreateBanner] = useState(false);
  const handleCloseBanner = () => setShowCreateBanner(false);
  const handleShowBanner = () => setShowCreateBanner(!showCreateBanner);
  const [modalFor, setModalFor] = useState(null);
  const user = JSON.parse(localStorage.getItem("Usuario"))?.UserLogin?.name;
  const { values, setValues, handleInputChangeProduct, reset } = useForm({
    type: "productoLinea",
    title: "",
    top: "",
    top_mobile: "",
    titleSubDescription: "",
    subdescription: "",
    benefit: [],
    filename: [],
    instalationSteps: [],
    imageInstallation: [],
    faqs: [],
    faqsEnabled: true,
    altImageBackground: "",
    imageBackground: [],
    imageBackground_tablet: [],
    imageBackground_mobile: [],
    imageGallery: [],
    galleryEnabled: true,
    imageLogo: [],
    imageLogoColor: [],
    imageProduct: [],
    imageProductAlpha: [],
    imageCarousel: [],
    imageIcon: [],
    imageIconColor: [],
    image_desktop: [],
    state: true,
    visible: false
    // publish: false,
  });

  useEffect(() => {
    setValues(values);
  }, [values]);

  useEffect(() => {
    getAllProducts({ onlyTitleAndIcon: false, visible: true });
  }, []);

  const [showGaleria, setShowGaleria] = useState(false);
  const handleCloseGaleria = () => setShowGaleria(false);
  const handleShowGaleria = () => setShowGaleria(true);

  const handleDeleteBenefit = (id) => {
    setValues({
      ...values,
      benefit: values?.benefit?.filter((item, i) => item?._id !== id)
    });
  };

  const handleBenefitInput = ({ target }) => {
    setValues({
      ...values,
      benefit: values.benefit?.map((item, i) => {
        if (i === Number(target.id)) {
          return { ...item, [target.name]: target.value };
        }
        return item;
      })
    });
  };

  const handleAddBenefit = () => {
    isEdit
      ? setValues({
          ...values,
          benefit: [...values?.benefit, { iconBenefit: "", textBenefit: "", _id: idGenerator(12) }]
        })
      : setValues({
          ...values,
          benefit: [
            ...(values?.benefit ? values?.benefit : ""),
            { iconBenefit: "", textBenefit: "", _id: idGenerator(12) }
          ]
        });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let imageBackgroundValidate = false;
    let imageProductValidate = false;

    const title = values.title.trim();

    if (!title || !titleRegex.test(title)) {
      toast.error("Este título contiene caracteres no válidos");
      return;
    }

    if (values.imageBackground.length <= 0) {
      toast.error("La imagen de fondo es Requerida");
    } else {
      imageBackgroundValidate = true;
    }

    if (values.imageProduct.length <= 0) {
      toast.error("La imagen del Producto es Requerida");
    } else {
      imageProductValidate = true;
    }

    /* Beneficios */
    const benefitsFields = Array.from(document.getElementsByClassName("fieldBenefit"));

    let someEmpty = benefitsFields.some((field) => {
      return field.value === "";
    });

    if (benefitsFields.length === 0 || someEmpty) {
      toast.error("No pueden haber campos de Beneficios vacíos");
      return;
    }

    if (imageBackgroundValidate && imageProductValidate) {
      try {
        const { data } = await createAuditRequest({
          ...values,
          deleted: false,
          element: 2,
          creator: user,
          publish: true
        });
        setProducts([...products, values]);
        toast.success("Se creó el producto");
        reset();
      } catch (error) {
        toast.error("Error al crear el producto");
      }
    }
  };

  const handleAddStep = () => {
    setValues({
      ...values,
      instalationSteps: [
        ...values.instalationSteps,
        {
          _id: Number(Math.random()),
          stepTitle: "",
          stepDescription: "",
          stepWarningText: ""
        }
      ],
      imageInstallation: [...values.imageInstallation]
    });
  };

  const handleStepInput = ({ target }) => {
    setValues({
      ...values,
      instalationSteps: values.instalationSteps.map((step, i) => {
        if (step._id === Number(target.id)) {
          return { ...step, [target.name]: target.value };
        }
        return step;
      })
    });
  };

  const handleDeleteStep = (index) => {
    setValues({
      ...values,
      instalationSteps: values.instalationSteps.filter((step, i) => i !== index)
    });
  };

  const handleAddFaqs = () => {
    setValues({
      ...values,
      faqs: [...values.faqs, { _id: Number(Math.random()), question: "", answer: "" }]
    });
  };

  const handleFaqsInput = ({ target }) => {
    setValues({
      ...values,
      faqs: values.faqs.map((faq, i) => {
        if (faq._id === Number(target.id)) {
          return { ...faq, [target.name]: target.value };
        }
        return faq;
      })
    });
  };

  const handleDeleteFaq = (index) => {
    setValues({ ...values, faqs: values.faqs.filter((faq, i) => i !== index) });
  };

  const handleModalClick = (modalFor) => {
    setModalFor(modalFor);
    handleShowGaleria();
  };

  return (
    <div className="pgi__sidebar-slides">
      {replicaPgi ? (
        <button
          className=" settings_button-pleno overlay-replica-button"
          onClick={handleShowBanner}
        >
          {" "}
          Nuevo Producto
        </button>
      ) : (
        <OverlayTrigger key="1" placement="top" overlay={<Tooltip id="1">Nuevo Producto</Tooltip>}>
          <Button className="btn-form-pgi" variant="light" onClick={handleShowBanner}>
            <AddOutlined />
          </Button>
        </OverlayTrigger>
      )}
      {/**INICIO OFF CANVAS */}
      <Offcanvas
        show={showCreateBanner}
        onHide={handleCloseBanner}
        className="basePgi__pgi  pgi__sidebar-container"
        placement="end"
        scroll="true"
        enforceFocus
        backdrop={false}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            Nuevo Producto
            {/* EN EDITAR el title -->
                Producto / <b>Tensoblock</b> */}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form className="basePgi__vista-edit-gral" id="bloque-txt" onSubmit={handleSubmit}>
            <div>
              <button
                type="submit"
                className="settings_button-pleno float-end mb-3 botton-save-pgi"
              >
                GUARDAR
              </button>
            </div>
            <Tabs
              defaultActiveKey="descripcion"
              active
              id="productos-tab"
              className="pgi__productos-tab"
            >
              <Tab eventKey="descripcion" title="Descripción">
                <form className="basePgi__vista-edit-gral" id="bloque-txt">
                  <fieldset className="pgi__sidebar-container-items form-group">
                    <div className="form-floating pgi__selectProduct">
                      <h3 className="basePgi__comments">Tipo de producto</h3>
                      {/* determina ALINEACION DEL BLOQUE DE TXT en pantalla, INCORPORAR el class "align-left" <div className="carousel align-left"></div> */}
                      <Form.Check
                        inline
                        label="Producto Especial"
                        name="type"
                        type="radio"
                        id="productoEspecial"
                        value="productoEspecial"
                        onChange={handleInputChangeProduct}
                      />
                      {/* determina ALINEACION DEL BLOQUE DE TXT en pantalla, INCORPORAR el class "align-center" <div className="carousel align-center"></div> */}
                      <Form.Check
                        inline
                        label="Producto de Línea"
                        name="type"
                        type="radio"
                        id="productoLinea"
                        value="productoLinea"
                        onChange={handleInputChangeProduct}
                      />
                    </div>
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        id="title"
                        placeholder="..."
                        value={values.title}
                        onChange={handleInputChangeProduct}
                        required
                        maxLength={30}
                        minLength={2}
                      />
                      <label htmlFor="title">Nombre del producto </label>
                      <p className="basePgi__comments">
                        <span>No se admiten los siguentes caracteres: "" ( ) * - / </span>
                      </p>
                    </div>

                    <div className="form-floating">
                      <textarea
                        required
                        type="text-area"
                        className="form-control"
                        name="top"
                        id="top"
                        rows="6"
                        for="bloque-txt"
                        value={values.top}
                        onChange={handleInputChangeProduct}
                        placeholder="hola"
                        maxLength={280}
                        minLength={2}
                      />
                      <label htmlFor="top">Descripción</label>
                      <p className="basePgi__comments">
                        <span>Máximo de caracteres: 280.</span>
                      </p>
                    </div>
                    <div className="form-floating">
                      <textarea
                        required
                        type="text-area"
                        className="form-control"
                        name="top_mobile"
                        id="top_mobile"
                        rows="6"
                        for="bloque-txt"
                        value={values.top_mobile}
                        onChange={handleInputChangeProduct}
                        placeholder="hola"
                        maxLength={144}
                        minLength={2}
                      />
                      <label htmlFor="top_mobile">Descripción para dispositivos móviles</label>
                      <p className="basePgi__comments">
                        <span>Máximo de caracteres: 144.</span>
                      </p>
                    </div>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("fondo")}
                    >
                      Fondo desktop
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Escritorio (.jpg, .png). Proporción 16:9. Ancho máximo 2048px
                      </span>
                    </p>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("fondo_tablet")}
                    >
                      Fondo tablet
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Tablet (.webP, .jpg, .png). Proporción 4:3. Ancho máximo 2048px
                      </span>
                    </p>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("fondo_mobile")}
                    >
                      Fondo mobile
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen Mobile (.webP, .jpg, .png). Proporción 9:16. Ancho máximo 1200px
                      </span>
                    </p>
                    <div className="form-floating mt-3">
                      <input
                        type="text"
                        className="form-control"
                        name="altImageBackground"
                        id="altImageBackground"
                        placeholder="..."
                        value={values.altImageBackground}
                        onChange={handleInputChangeProduct}
                        maxLength={90}
                      />
                      <label htmlFor="altImageBackground">
                        Ingrese un ALT para la imagen principal{" "}
                      </label>
                    </div>
                    <hr className="basePgi__space-line" />
                    <div className="pgi__sidebar-container-items">
                      <h3>Ítems destacados</h3>
                      <p className="basePgi__comments">
                        Desde aquí podrá cargar cada beneficio de producto y su ícono personalizado.
                      </p>
                      <div className="pgi__archivo pgi__install">
                        {values?.benefit?.map((item, i) => {
                          return (
                            <div className="mx-3">
                              <label htmlFor="title">{i + 1}</label>
                              <OverlayTrigger
                                key="1"
                                placement="top"
                                overlay={<Tooltip id="1">Eliminar</Tooltip>}
                              >
                                <Button onClick={() => handleDeleteBenefit(item?._id)}>
                                  <DeleteForeverOutlined />
                                </Button>
                              </OverlayTrigger>
                              <div key={item?._id}>
                                <div className="input-group my-4">
                                  <small className="d-block w-100">Ícono de beneficio</small>
                                  <input
                                    type="text"
                                    className="form-control fieldBenefit"
                                    name="iconBenefit"
                                    placeholder="Ícono"
                                    id={i}
                                    defaultValue={item?.iconBenefit}
                                    onChange={handleBenefitInput}
                                    maxLength={90}
                                    minLength={2}
                                    required
                                  />
                                  <small className="d-block w-100 mt-3">Texto del beneficio</small>
                                  <input
                                    type="text"
                                    className="form-control fieldBenefit"
                                    name="textBenefit"
                                    placeholder="Texto"
                                    id={i}
                                    defaultValue={item?.textBenefit}
                                    onChange={handleBenefitInput}
                                    maxLength={90}
                                    minLength={2}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <OverlayTrigger
                        key="1"
                        placement="top"
                        overlay={<Tooltip id="1">Nuevo Link</Tooltip>}
                      >
                        <Button
                          variant="light"
                          className="btn-form-pgi allW"
                          onClick={handleAddBenefit}
                        >
                          <AddOutlined />
                        </Button>
                      </OverlayTrigger>
                    </div>
                  </fieldset>
                  <hr className="basePgi__space-line" />
                  <fieldset className="pgi__sidebar-container-items form-group">
                    <h3>Contenido</h3>
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        name="titleSubDescription"
                        id="titleSubDescription"
                        value={values.titleSubDescription}
                        onChange={handleInputChangeProduct}
                        required
                        maxLength={80}
                        minLength={2}
                      />
                      <label htmlFor="titleSubDescription">Subtítulo</label>
                      <p className="basePgi__comments">
                        <span>Máximo de caracteres: 80.</span>
                      </p>
                    </div>
                    <div className="form-floating">
                      <div className="mt-5">
                        <TinyMCE
                          values={values.subdescription}
                          handleInputChange={handleInputChangeProduct}
                          name={"subdescription"}
                        />
                      </div>
                      <label htmlFor="subdescription">Descripción</label>
                    </div>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50 btn-big-img"
                      onClick={() => handleModalClick("imagen_producto")}
                    >
                      Imágenes descripción (2)
                      <WidgetsOutlined />
                    </Button>
                    <p className="basePgi__comments">
                      <span>
                        Imagen para Escritorio (.jpg, .png). Proporción 4:3. Ancho máximo 2048px
                      </span>
                    </p>
                  </fieldset>
                  <hr className="basePgi__space-line" />
                  {/* <button type="submit" className="settings_button-pleno">
                    GUARDAR
                  </button> */}
                </form>
              </Tab>
              {/* *************TABS IMAGENES *************************************** */}
              <Tab eventKey="imagenes" title="Imágenes">
                <form className="basePgi__vista-edit-gral">
                  <div className="form-floating">
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("logotipo")}
                    >
                      Logotipo Negativo
                      <BookmarkBorderOutlined />
                    </Button>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("logotipo-color")}
                    >
                      Logotipo Positivo
                      <BookmarkBorderOutlined />
                    </Button>

                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("icono")}
                    >
                      Ícono
                      <AppsOutlined />
                    </Button>

                    {/*implementar: al editar banner cambiar x "REEMPLAZAR"*/}
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("imagen_producto-alpha")}
                    >
                      Imagen producto
                      <WidgetsOutlined />
                    </Button>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("imagen_carousel")}
                    >
                      Producto Carousel
                      <WidgetsOutlined />
                    </Button>
                  </div>
                </form>
                <hr className="basePgi__space-line" />
                {/*SELECCIONAR GALERíA*/}
                <form className="basePgi__vista-edit-gral">
                  <div className="form-floating">
                    <h3 className="basePgi__comments">Galería Fotográfica</h3>
                    <Form.Check
                      defaultChecked={values.galleryEnabled}
                      type="switch"
                      id="pgigalerySwitch"
                      label="Habilitar Galería"
                      className="pgi__switchCheck"
                      name="galleryEnabled"
                      onChange={handleInputChangeProduct}
                    />
                    <div className="pgi__container-img" style={{ display: "none" }}>
                      {/*implementar selector de images *** eliminar style={{}} al agregar imagenes*/}
                    </div>
                    {/* MODAL GALERIA */}
                    <Modal
                      id="galleryModal"
                      className="modalContenedor__galeria"
                      show={showGaleria}
                      onHide={handleCloseGaleria}
                    >
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>
                        <GaleriaPgiModal
                          editProduct={values}
                          setEditProduct={setValues}
                          modalFor={modalFor}
                          handleCloseGaleria={handleCloseGaleria}
                        />
                      </Modal.Body>
                    </Modal>
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm"
                      onClick={() => handleModalClick("album")}
                    >
                      Seleccionar Álbum
                      <WallpaperOutlined />
                    </Button>
                    {/*implementar selector de images *** eliminar style={{}} al agregar imagenes*/}
                  </div>
                </form>
                <hr className="basePgi__space-line" />
              </Tab>
              {/* *************TABS FAQs *************************************** */}

              <Tab eventKey="faqs" title="Faqs">
                <Form className="basePgi__vista-edit-gral">
                  <Form.Check
                    defaultChecked={values.faqsEnabled}
                    type="switch"
                    id="pgiFaqsSwitch"
                    label="Habilitar Faqs"
                    className="pgi__switchCheck"
                    name="faqsEnabled"
                    onChange={handleInputChangeProduct}
                  />

                  <fieldset className="pgi__sidebar-container-items">
                    <h3>Preguntas y respuestas</h3>
                    <p className="basePgi__comments">
                      Desde aquí podrá cargar las preguntas y respuestas referidas a cada producto
                    </p>
                    <div className="pgi__archivo pgi__install">
                      {values.faqs.map((faq, index) => {
                        return (
                          <>
                            <div className="input-group" key={faq._id}>
                              <label htmlFor="question">{index + 1}</label>
                              <input
                                type="text"
                                className="form-control"
                                name={`question`}
                                placeholder="Titulo"
                                id={faq._id}
                                value={faq.question}
                                onChange={handleFaqsInput}
                                required
                                maxLength={90}
                                minLength={2}
                              />
                              <OverlayTrigger
                                key="1"
                                placement="top"
                                overlay={<Tooltip id="1">Eliminar</Tooltip>}
                              >
                                <Button onClick={() => handleDeleteFaq(index)}>
                                  <DeleteForeverOutlined />
                                </Button>
                              </OverlayTrigger>
                            </div>
                            {/* <textarea
                              type="text-area"
                              className="form-control"
                              name={`answer`}
                              placeholder="Descripción"
                              id={faq._id}
                              value={faq.answer}
                              onChange={handleFaqsInput}
                              required
                              minLength={2}
                            /> */}
                            <TinyMCE
                              id={faq._id}
                              values={faq.answer}
                              handleInputChange={handleFaqsInput}
                              name={"answer"}
                            />
                            <input
                              type="text"
                              className="form-control py-2"
                              name={`video`}
                              placeholder="Enlace video"
                              id={faq._id}
                              value={faq.video}
                              onChange={handleFaqsInput}
                              maxLength={100}
                            />
                          </>
                        );
                      })}
                      {/*implementar selector de images *** eliminar style={{}} al agregar imagenes*/}
                    </div>
                    <OverlayTrigger
                      key="1"
                      placement="top"
                      overlay={<Tooltip id="1">Nueva pregunta</Tooltip>}
                    >
                      <Button variant="light" className="btn-form-pgi allW" onClick={handleAddFaqs}>
                        <AddOutlined />
                      </Button>
                    </OverlayTrigger>
                  </fieldset>
                </Form>
                <hr className="basePgi__space-line" />
              </Tab>
              {/* *************TABS INSTALACIÓN *************************************** */}

              <Tab eventKey="instalacion" title="Instalación">
                <Form className="basePgi__vista-edit-gral">
                  <Form.Check
                    type="switch"
                    id="pgiInstallSwitch"
                    label="Habilitar botón"
                    className="pgi__switchCheck"
                  />

                  <fieldset className="pgi__sidebar-container-items">
                    <h3>Pasos</h3>
                    <p className="basePgi__comments">
                      Desde aquí podrá cargar los pasos de la instalación de un producto
                    </p>
                    <div className="pgi__archivo pgi__install">
                      {values.instalationSteps.map((step, index) => {
                        return (
                          <>
                            <div className="input-group" key={step._id}>
                              <label htmlFor="stepTitle">{index + 1}</label>
                              <input
                                type="text"
                                className="form-control"
                                name={`stepTitle`}
                                placeholder="Paso"
                                id={step._id}
                                value={step.stepTitle}
                                onChange={handleStepInput}
                                maxLength={90}
                                minLength={2}
                              />
                              <OverlayTrigger
                                key="1"
                                placement="top"
                                overlay={<Tooltip id="1">Eliminar</Tooltip>}
                              >
                                <Button onClick={() => handleDeleteStep(index)}>
                                  <DeleteForeverOutlined />
                                </Button>
                              </OverlayTrigger>
                            </div>
                            <textarea
                              type="text-area"
                              className="form-control"
                              name={`stepDescription`}
                              placeholder="Descripción"
                              id={step._id}
                              value={step.stepDescription}
                              onChange={handleStepInput}
                              minLength={2}
                            />
                            <input
                              type="text"
                              className="form-control py-2"
                              name={`stepWarningText`}
                              placeholder="Texto de Advertencia"
                              id={step._id}
                              value={step.stepWarningText}
                              onChange={handleStepInput}
                              maxLength={284}
                              minLength={2}
                            />
                            <Button
                              className="btn-form-pgi pgi__head-modules"
                              onClick={() => handleModalClick("imageInstallation")}
                            >
                              Seleccionar imagen
                              <WallpaperOutlined />
                            </Button>
                          </>
                        );
                      })}
                      {/*implementar selector de images *** eliminar style={{}} al agregar imagenes*/}
                    </div>
                    <OverlayTrigger
                      key="1"
                      placement="top"
                      overlay={<Tooltip id="1">Nuevo paso</Tooltip>}
                    >
                      <Button variant="light" className="btn-form-pgi allW" onClick={handleAddStep}>
                        <AddOutlined />
                      </Button>
                    </OverlayTrigger>
                  </fieldset>
                </Form>
                <hr className="basePgi__space-line" />
              </Tab>
            </Tabs>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default SideBarProducts;
